module.exports = __webpack_public_path__ + "img/zgh_jxk.18d60307.svg";